import React from 'react';
import QlikReportsTypeComponent from './qlick-reports-type.component';
import QlikReportVisualisationComponent from './qlick-report-visualisation.component';
import PropTypes from 'prop-types';
import Notification from '../../common/notification/notification.component';
import Loading from '../../../components/loading/loading.component';
class QlikReportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curentReportIndex: 0
    };

    this.changeReport = this.changeReport.bind(this);
  }

  changeReport(index) {
    this.setState(() => ({
      curentReportIndex: index
    }));
  }

  render() {
    if (this.props.isFetching) {
      return <Loading />;
    } else if (this.props.reportsError) {
      return <Notification type="error" data={this.props.error} />;
    } else if (this.props.reports && this.props.reports.length > 0) {
      const index = this.state.curentReportIndex;
      const currentReport = this.props.reports[index];
      return (
        <div className="reports-container">
          <QlikReportsTypeComponent sheets={this.props.reports} changeReport={this.changeReport} />
          <QlikReportVisualisationComponent url={currentReport.presentationUrl} />
        </div>
      );
    } else {
      return <Notification type="info" data="No reports found." />;
    }
  }
}

QlikReportComponent.propTypes = {
  reports: PropTypes.any.isRequired,
  error: PropTypes.object,
  isFetching: PropTypes.bool
};
export default QlikReportComponent;
